import { list } from "./list";

export const campaign = {
    namespaced: true,
    modules: {
        list
    }
};



// WEBPACK FOOTER //
// ./src/store/campaign/campaign.js